import { smoothScrollTo } from './scrollUtils.js'

window.addEventListener('DOMContentLoaded', () => {
  const scrollDownBtns = document.getElementsByClassName('scroll_down')

  if (!window.requestAnimationFrame) {
    window.requestAnimationFrame = function (callback) {
      return setTimeout(callback, 16)
    }
  }

  Array.from(scrollDownBtns).forEach((scrollDownBtn) => {
    setScrollDownBtnPosition(scrollDownBtn)

    scrollDownBtn.addEventListener('click', (e) => {
      e.preventDefault()
      const target = document.getElementsByClassName('content-box')[0]
      const start = window.scrollY
      const targetPosition = target.getBoundingClientRect().top + start - 50
      smoothScrollTo(targetPosition, start)
    })
  })

  // スクロールダウンボタンの位置を設定
  function setScrollDownBtnPosition(scrollDownBtn) {
    const parentScrollDownBtn = scrollDownBtn.parentElement
    parentScrollDownBtn.classList.remove("center", "under")
   
    const catchCopy = document.getElementsByClassName('text-align-wrapper')[0]
    // キャッチコピーが存在しないまたは空の場合、スクロールダウンボタンを下に表示
    if (!catchCopy || !catchCopy.textContent){
      parentScrollDownBtn.classList.add("under")
    // 上揃えまたは中央揃えの場合、スクロールダウンボタンを下に表示
    }else if (catchCopy.classList.contains("text-align-start") || catchCopy.classList.contains("text-align-center") || catchCopy.classList.contains("center")) {
      parentScrollDownBtn.classList.add("under")
    // 下揃えの場合、スクロールダウンボタンを中央に表示
    }else if(catchCopy.classList.contains("text-align-end") || catchCopy.classList.contains("end")){
      parentScrollDownBtn.classList.add("center")
    }
  }
})
